import React, { useState, useEffect } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import {
  durationOfContractArray,
  probationPeriodArray,
  putGroupEdit,
  religionArray,
  statusArray,
} from "../../candidateListFunctions";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

const statusForupdateFlightDetails = [
  "VISA STAMPED",
  // "VISA CANCELLED REQUIREMENT FULFILLED",
  "VISA CANCELLED",
];

export default function GroupEditPopupVisaDetails({
  popupState,
  setPopupState,
  candidateData,
  setCandidateListData,
  checkedList,
  hideInputs = [],
  ResetFilter,
}) {
  const { projectId } = useParams();
  const dispatch = useDispatch();

  const [finalObj, setFinalObj] = useState({});

  const [submitLoading, setSubmitLoading] = useState(false);

  const handleGroupEdit = async (e) => {
    e.preventDefault();
    const body = [];
    for (let selectedId of checkedList) {
      body.push({
        ...finalObj,
        id: selectedId,
      });
    }
    const response = await putGroupEdit(
      projectId,
      body,
      setCandidateListData,
      setSubmitLoading,
      dispatch
    );
    if (response.completed) {
      ResetFilter();
      setPopupState({ open: false });
    }
  };

  const [visaBlockData, setVisaBlockData] = useState();
  const [uniequVisaBlock,setUniqueVisaBlock] = useState()

  useEffect(() => {
    console.log(uniequVisaBlock);
    if (uniequVisaBlock ) {
      const projectVisaArray = uniequVisaBlock;

      const matchingProjectVisa = projectVisaArray.find(
        (visa) => visa.vrf_visa.visa_block_number == finalObj?.visa_block_number
      );

      if (matchingProjectVisa) {
        setVisaBlockData(matchingProjectVisa);
        // setFinalObj((prevState) => ({
        //   ...prevState,
        //   visa_profession_id: matchingProjectVisa.vrf_visa.visa_profession.id,
        // }));
      } else {
        console.log("No matching project_visa found for sector ID");
      }
    }
  }, [finalObj,uniequVisaBlock]);

  console.log(finalObj, "finalObj");

  const [confirmCheckBox, setConfirmCheckBox] = useState(false);

  useEffect(() => {
    const uniqueVisasByBlock = {};
  
    // Iterate through project_visa array
    candidateData?.project_visa?.forEach((visa) => {
      const visaBlockNumber = visa?.vrf_visa?.visa_block_number;
  
      // Check if block_number already exists in uniqueVisasByBlock
      if (!uniqueVisasByBlock[visaBlockNumber]) {
        // If not, add the current visa as an array with visa_profession
        uniqueVisasByBlock[visaBlockNumber] = {
          ...visa.vrf_visa,
          ...visa,
          vrf_visa: {
            ...visa.vrf_visa,
            visa_professions: [visa.vrf_visa.visa_profession],
          },
        };
      } else {
        // If block_number already exists, add visa_profession to the array
        uniqueVisasByBlock[visaBlockNumber].vrf_visa.visa_professions.push(
          visa.vrf_visa.visa_profession
        );
      }
    });
  
    // Step 2: Convert the values of the uniqueVisasByBlock object to an array
    const uniqueVisas = Object.values(uniqueVisasByBlock);
    setUniqueVisaBlock(uniqueVisas);
  }, []);
  

  console.log(uniequVisaBlock,"aldfjkasf");


  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
        popupState.open ? "flex" : "hidden"
      }`}
    >
      <div className="max-w-xl w-full h-auto min-h-[15rem] max-h-[35rem] rounded-md bg-white/95 flex  flex-col p-4 relative overflow-y-scroll">
        <div className="flex justify-between items-center w-full">
          <div>
            <h1 className="text-xl font-semibold">Group Edit</h1>
            <h2 className="text-sm">Group Edit Candidate List</h2>
          </div>
          <h1
            className="text-md font-semibold cursor-pointer"
            onClick={() => {
              setPopupState((p) => ({ open: false }));
            }}
          >
            <IoMdClose />
          </h1>
        </div>
        <form className="px-5 py-2 mt-5" onSubmit={handleGroupEdit}>
          {/* <ArraySelectInput
            title="VISA Block Number"
            array={candidateData?.project_visa}
            objKey="visa_block_number"
            setFinalObj={setFinalObj}
            hideInputs={hideInputs}
          /> */}
          <div className={`form-control w-full gap-[0.15rem] mb-4 `}>
            <label className="label py-0">
              <span className="label-text">VISA Block Number</span>
            </label>
            <select
              className="select select-sm select-bordered"
              onChange={(e) =>
                setFinalObj((prevState) => ({
                  ...prevState,
                  visa_block_number: e.target.value,
                }))
              }
              required
            >
              <option value="" hidden>
                Select an Option
              </option>
              {uniequVisaBlock?.map((item) => (
                <option
                  value={item?.visa_block_number}
                  key={item?.visa_block_number}
                >
                  {item?.visa_block_number}
                </option>
              ))}
            </select>
          </div>
          {finalObj?.visa_block_number && (
            <div className={`form-control w-full gap-[0.15rem] mb-4 `}>
            <label className="label py-0">
              <span className="label-text">VISA PROFESSION</span>
            </label>
            <select
              className="select select-sm select-bordered"
              onChange={(e) =>
                setFinalObj((prevState) => ({
                  ...prevState,
                  visa_profession_id: e.target.value,
                }))
              }
              required
            >
              <option value="" hidden>
                Select an Option
              </option>
              {visaBlockData?.vrf_visa?.visa_professions?.map((item) => (
                <option
                  value={item?.id}
                  key={item?.id}
                >
                  {item?.name}
                </option>
              ))}
            </select>
          </div>
          )}

          <TextInput
            title="REFERENCE NO"
            objKey="visa_reference_number"
            setFinalObj={setFinalObj}
            hideInputs={hideInputs}
            required
          />
          <TextInput
            type="date"
            title="VISA Stamping Date"
            objKey="visa_stamping_date"
            setFinalObj={setFinalObj}
            hideInputs={hideInputs}
            required
          />
          <ArraySelectInput
            title="Status"
            array={statusForupdateFlightDetails}
            objKey="status"
            setFinalObj={setFinalObj}
            hideInputs={hideInputs}
            required
          />
          {finalObj?.status == "VISA CANCELLED" && (
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">COMMENTS</label>
              <textarea
                rows={2}
                className="input-sm w-full input input-bordered"
                type="text"
                name="visa_cancelled_comments"
                placeholder="Add Your Comments"
                onChange={(e) => {
                  setFinalObj((prevState) => ({
                    ...prevState,
                    visa_cancelled_comments: e.target.value,
                  }));
                }}
                required
              />
            </div>
          )}

          {finalObj?.status == "VISA CANCELLED" && (
            <div>
              <div className="flex gap-2">
                <input
                  required
                  className="checkbox"
                  type="checkbox"
                  onChange={(e) => setConfirmCheckBox(e.target.value)}
                />
                <span className="block text-left mb-1 ml-1 text-sm text-red">
                  Are you sure if the details have been removed from ENJAZ
                  Portal
                </span>
              </div>
            </div>
          )}
          <div className="p-2  w-full flex gap-3">
            <button
              type="button"
              className="ring-1 ring-slate-300  uppercase w-full text-xs rounded-md py-2 flex justify-center items-center gap-2"
              disabled={submitLoading}
              onClick={() => setPopupState({ open: false })}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={
                "bg-red uppercase w-full text-xs text-white rounded-md py-2 flex justify-center items-center gap-2"
              }
              disabled={submitLoading}
            >
              Submit
              {submitLoading && <CgSpinner className="animate-spin" />}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const ArraySelectInput = ({
  title,
  array,
  arrayValue,
  objKey,
  setFinalObj,
  hideInputs = [],
  required = false,
}) => {
  return (
    <div
      className={`form-control w-full gap-[0.15rem] mb-4 ${
        hideInputs.includes(objKey) ? "hidden" : ""
      }`}
    >
      <label className="label py-0">
        <span className="label-text">{title}</span>
      </label>
      <select
        className="select select-sm select-bordered"
        onChange={(e) =>
          setFinalObj((prevState) => ({
            ...prevState,
            [objKey]: e.target.value,
          }))
        }
        required={required}
      >
        <option value="" hidden>
          Select an Option
        </option>
        {array?.map((data) => (
          <option value={data?.id || data} key={data?.id}>
            {data?.name || data}
          </option>
        ))}
      </select>
    </div>
  );
};

const TextInput = ({
  title,
  type,
  objKey,
  setFinalObj,
  hideInputs,
  required = false,
}) => {
  return (
    <div
      className={`form-control w-full gap-[0.15rem] mb-4 ${
        hideInputs.includes(objKey) ? "hidden" : ""
      }`}
    >
      <label className="label py-0">
        <span className="label-text">{title}</span>
      </label>
      <input
        required={required}
        type={type || "text"}
        placeholder="Type here"
        className="input input-sm input-bordered w-full"
        onChange={(e) => {
          if (String(e.target.value).trim() != "") {
            setFinalObj((prevState) => ({
              ...prevState,
              [objKey]:
                type == "date"
                  ? String(e.target.value).split("-").reverse().join("-")
                  : e.target.value,
            }));
          } else {
            setFinalObj((prevState) => {
              const copyFinalObj = { ...prevState };
              delete copyFinalObj[objKey];
              return copyFinalObj;
            });
          }
        }}
      />
    </div>
  );
};
